import { render, staticRenderFns } from "./ZonesForm.vue?vue&type=template&id=3275ece2&scoped=true&"
import script from "./ZonesForm.vue?vue&type=script&lang=js&"
export * from "./ZonesForm.vue?vue&type=script&lang=js&"
import style0 from "./ZonesForm.vue?vue&type=style&index=0&id=3275ece2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3275ece2",
  null
  
)

export default component.exports